module.exports = __webpack_public_path__ + "WebComponentsIcons.b45bf89b88f9372c3fe2.eot";


//////////////////
// WEBPACK FOOTER
// /Users/muhammadfiqihfirdiansyah/Documents/Muhammad Fiqih Firdiansyah/Project/Angular/BODES/BODES.Web.UI.Angular4/external_css/kendo-ui/fonts/glyphs/WebComponentsIcons.eot?gedxeo
// module id = ../../../../../external_css/kendo-ui/fonts/glyphs/WebComponentsIcons.eot?gedxeo
// module chunks = styles